import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useContent } from 'contexts/content-context';

import {
  Table,
  Icon,
  TextWithTooltip
} from 'components/common/Elements/Elements';

import { deviceTableConf } from '../../helpers/configurates';
import { statusStyle } from '../../helpers/helpers';

import classes from './SubTable.module.scss';

const SubTable = ({ row, mouseLeave, mouseEnter, dataSub }) => {
  const { contentState } = useContent();
  const [tunnels, setTunnels] = useState(dataSub);
  useEffect(() => {
    async function getActualStatus() {
      const newTunnels = tunnels.map(tunnel => {
        const componentStatus = contentState.actualStatus.find(
          itemStatus => itemStatus.id == tunnel.tunnelId
        );
        return {
          ...tunnel,
          actualStatus: componentStatus ? componentStatus.status : 'NA'
        };
      });
      setTunnels(newTunnels);
    }
    getActualStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSub, contentState]);
  return (
    <Table.Row className={classes.subTable_wrap}>
      <Table.Cell colSpan={4} className={classes.resetCell}>
        <div
          style={{ height: `calc(50px + ${tunnels.length * 66}px)` }}
          className={classes.fixCell}
        >
          <div className={classes.headerDecor} />
          <Table className={classes.subTable}>
            <Table.Header>
              <Table.Row>
                {deviceTableConf.map(({ field, title }, idx) => (
                  <Table.HeaderCell
                    key={field}
                    className={classes.subTable_header}
                    onMouseEnter={mouseEnter}
                    onMouseLeave={mouseLeave}
                    r={`r${idx + 10}`}
                    title={title}
                  />
                ))}
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {tunnels.map(divice => (
                <Table.Row
                  key={divice.tunnelId}
                  className={classes.subTable_row}
                >
                  <Table.Cell
                    className={cn(
                      classes.subTable_cell,
                      row === 'r10' && classes.hov
                    )}
                    isId
                    onMouseEnter={mouseEnter}
                  >
                    <Icon
                      icon="parentLine"
                      size="73px"
                      className={cn(classes.child, classes.child_l)}
                    />
                    <Icon
                      icon="parentS"
                      size="50px"
                      className={cn(classes.child, classes.child_s)}
                    />

                    {divice.tunnelId}
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.subTable_cell,
                      row === 'r11' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    {divice.tunnelName}
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.subTable_cell,
                      row === 'r12' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    {divice.tunnelType}
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      statusStyle(divice.actualStatus),
                      classes.subTable_cell,
                      row === 'r13' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    {divice.actualStatus || 'NA'}
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.subTable_cell,
                      row === 'r14' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    {divice.tunnelIp}
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.subTable_cell,
                      row === 'r15' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    <div className={classes.subnetsCell}>
                      <TextWithTooltip
                        text={
                          divice.leftSubnets !== '[]'
                            ? divice.leftSubnets
                            : 'NA'
                        }
                      />
                    </div>
                  </Table.Cell>
                  <Table.Cell
                    className={cn(
                      classes.subTable_cell,
                      row === 'r16' && classes.hov
                    )}
                    onMouseEnter={mouseEnter}
                  >
                    <div style={{ width: '150px' }}>
                      <TextWithTooltip
                        text={
                          divice.customerSubnets !== '[]'
                            ? divice.customerSubnets
                            : 'NA'
                        }
                      />
                    </div>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      </Table.Cell>
    </Table.Row>
  );
};

SubTable.propTypes = {
  row: PropTypes.string,
  mouseLeave: PropTypes.func,
  mouseEnter: PropTypes.func,
  dataSub: PropTypes.array.isRequired
};

export default SubTable;
